import { render, staticRenderFns } from "./DesignSelector.vue?vue&type=template&id=a0fb795a&"
import script from "./DesignSelector.vue?vue&type=script&lang=js&"
export * from "./DesignSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports